import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductBundleOptionContainer as SourceProductBundleOptionContainer
} from 'SourceComponent/ProductBundleOption/ProductBundleOption.container';
import { ProductType } from 'Type/ProductList.type';
import { getEncodedBundleUid } from 'Util/Product/Transform';

/** @namespace Elganso/Component/ProductBundleOption/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/ProductBundleOption/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/ProductBundleOption/Container */
export class ProductBundleOptionContainer extends SourceProductBundleOptionContainer {
    static propTypes = {
        ...this.propTypes,
        product: ProductType
    };

    static defaultProps = {
        product: null
    };

    containerFunctions = {
        ...this.containerFunctions,
        getIsChecked: this.getIsChecked.bind(this)
    };

    containerProps() {
        const { product } = this.props;

        return {
            ...super.containerProps(),
            product
        };
    }

    getIsChecked(canChangeQuantity, uid, quantity) {
        const { activeSelectUid } = this.state;
        const value = canChangeQuantity ? getEncodedBundleUid(uid, quantity) : uid;

        return value === activeSelectUid;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductBundleOptionContainer);
